import { sectorSliceHalfHeight } from './sectorSliceSurface.js';
function clampAngularGapFraction(value) {
    return Math.min(Math.max(value ?? 0, 0), 0.95);
}
export function resolveEffectiveEntityShape(args) {
    const { layout, itemParametricState, itemCount } = args;
    if (layout?.layoutKind !== 'sector-ring') {
        return itemParametricState?.shape;
    }
    const slotSpan = itemCount <= 1 ? Math.PI * 2 : (Math.PI * 2) / itemCount;
    const span = slotSpan * (1 - clampAngularGapFraction(layout.angularGapFraction));
    const innerRadius = layout.innerRadius ?? 0;
    const outerRadius = layout.outerRadius;
    sectorSliceHalfHeight(innerRadius, outerRadius, layout.outerThickness);
    const midRadius = (innerRadius + outerRadius) / 2;
    const startAngle = -span / 2;
    const endAngle = span / 2;
    const declaredPresentation = itemParametricState?.shapePresentation;
    const presentation = declaredPresentation;
    const outlined = presentation?.appearanceMode === 'outlined';
    const bordered = !outlined && typeof presentation?.border?.color === 'string';
    const shape = {
        shapeKind: 'sector-slice',
        labelHostCapability: 'above-and-on',
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        ...(layout.outerThickness === undefined ? {} : { outerThickness: layout.outerThickness }),
        ...(layout.thicknessProfile === undefined ? {} : { thicknessProfile: layout.thicknessProfile }),
        ...(layout.arcSegments === undefined ? {} : { arcSegments: layout.arcSegments }),
        ...(presentation !== undefined && (outlined || bordered)
            ? {
                ...(presentation.appearanceMode === undefined ? {} : { appearanceMode: presentation.appearanceMode }),
                ...(presentation.border === undefined ? {} : { border: presentation.border }),
            }
            : {}),
        anchorsByKey: {
            center: { anchorKey: 'center', localPosition: [0, 0, midRadius] },
            arcMid: { anchorKey: 'arcMid', localPosition: [0, 0, outerRadius] },
            innerArcMid: { anchorKey: 'innerArcMid', localPosition: [0, 0, innerRadius] },
            startRadialMid: {
                anchorKey: 'startRadialMid',
                localPosition: [
                    Math.sin(startAngle) * midRadius,
                    0,
                    Math.cos(startAngle) * midRadius,
                ],
            },
            endRadialMid: {
                anchorKey: 'endRadialMid',
                localPosition: [
                    Math.sin(endAngle) * midRadius,
                    0,
                    Math.cos(endAngle) * midRadius,
                ],
            },
        },
    };
    return shape;
}
